import makeStyles from '@ui/utils/makeStyles';

export default makeStyles()((theme) => ({
  h1: {
    fontSize: 36,
    fontWeight: 500,
    [theme.breakpoints.up('md')]: {
      fontSize: 66,
    }
  },
  subhead: {
    fontSize: 14,
    color: theme.palette.common.black,
    [theme.breakpoints.up('md')]: {
      fontSize: 18,
    }
  },
  bfpWrapper: {
    margin: theme.spacing(4, 0),
  },
  bfpIcon: {
    width: 80,
    height: 80,
    marginBottom: theme.spacing(2)
  },
  bfpTitle: {
    color: theme.palette.common.black,
    marginBottom: theme.spacing(1),
    fontWeight: 'bold',
    fontSize: 14,
    [theme.breakpoints.up('md')]: {
      fontSize: 18,
    }
  },
  bfpCaption: {
    textAlign: 'center',
    maxWidth: 200,
    color: theme.palette.common.black,
    fontSize: 12,
    [theme.breakpoints.up('md')]: {
      fontSize: 14,
    }
  },
}));
